import { render, staticRenderFns } from "./Todo.vue?vue&type=template&id=6ca6b06d"
import script from "./Todo.vue?vue&type=script&lang=js"
export * from "./Todo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca6b06d')) {
      api.createRecord('6ca6b06d', component.options)
    } else {
      api.reload('6ca6b06d', component.options)
    }
    module.hot.accept("./Todo.vue?vue&type=template&id=6ca6b06d", function () {
      api.rerender('6ca6b06d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/TodoList/Todo.vue"
export default component.exports